import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: 22,
      gap: 50,
      '& h3': {
        fontSize: 24
      }
    },
    '& h3': {
      color: theme.palette.grey[900]
    }
  },
  headerAndButtons: {
    display: 'flex',
    gap: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 32,
    [theme.breakpoints.down('md')]: {
      gap: 120
    },
    [theme.breakpoints.down('sm')]: {
      gap: 50
    }
  },

  buttons: {
    display: 'flex',
    gap: 12,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      '& button': {
        '& span': {
          '& span': {
            marginRight: 0,
            marginLeft: 0
          }
        }
      }
    }
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 42,
    paddingTop: 6,
    paddingBottom: 6
  },
  filterForMobileSize: {
    position: 'absolute',
    top: 160,
    width: '100%',
    left: 0,
    borderRadius: '20px 20px 0px 0px',
    bottom: 0,
    overflowY: 'auto'
  },
  filterForMobileSizeModal: {
    backgroundColor: 'transparent',
    position: 'relative'
  }
}))

export default useStyles
